export function DownloadCsvFile(survey_id, data) {
  const anchor = document.createElement('a');
  anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(data);
  anchor.target = '_blank';
  anchor.download = `survey_${survey_id}_results.csv`;
  anchor.click();
}

export default DownloadCsvFile;
